const initialState = {
  isLoading: false,
  error: '',
  data: null,
};

export const getQuestionsListRequest = (state) => ({
  ...state,
  isLoading: true,
  error: '',
});

export const getQuestionsListSuccess = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: '',
    data: payload,
  };
};

export const getQuestionsListFailure = (state, { payload }) => {
  return {
    ...state,
    isLoading: false,
    error: payload,
  };
};

export default initialState;
